import { render } from "./Manuals.vue?vue&type=template&id=557d9e82&scoped=true"
import script from "./Manuals.vue?vue&type=script&lang=js"
export * from "./Manuals.vue?vue&type=script&lang=js"

import "./custom-manuals.scss?vue&type=style&index=0&id=557d9e82&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-557d9e82"]])

export default __exports__